import React from 'react';
import './ContactUsMenu.css';
import EmailIcon from '@mui/icons-material/Email';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const ContactUsMenu = () => {
  return (
    <>
     <div id='contact-us-menu'>
      <p><EmailIcon/> d.pandey@uniqutechnologies.com</p>
      <hr />
      <p><LocalPhoneIcon/>+91 99990 44355</p>
      <hr />
      <p><LocationOnIcon/> B-102,Sector 64, Noida - 201301</p>
     </div>
    </>
  )
}

export default ContactUsMenu
